import {
  hybrid,
  Hybrid,
  Orientation,
  isTouchable,
  os,
  screen,
  browser,
  orientation,
  type,
} from "@otto-ec/global-device";
import { o_global } from "../namespaces";

const device = {
  Hybrid,
  Orientation,
  isTouchable: isTouchable(),
  os: os(),
  screen,
  browser: browser(),
  orientation: orientation(),
  hybrid: undefined as unknown as Hybrid,
  type: type(),
  /*                                                   */
  /*                                                */
  breakpoint: o_global.breakpoint,
};

export type GlobalDevice = typeof device;

/*                                                */
o_global.device ||= device;
o_global.device.hybrid = hybrid();
